import { makeTrackingSDK } from '@frete.com/tracking-sdk';
import {
  TRACKING_ENDPOINT,
  representativeTrackingEndpoint,
  representativeTrackingHttpClient,
  trackingHttpClient,
} from './tracking-http-client';

const TRACKING_CONFIG = {
  source: { app: 'onboarding-frontend' },
  flushIntervalMs: 30000,
  baseRetryDelayMs: 1000,
  maxRetries: 3,
} as const;

/**
 * Uma instância por link: o uuid é a credencial da jornada e viaja no header,
 * então o transporte precisa conhecê-lo. `makeTrackingSDK` é idempotente por
 * `name` — nomear pelo link mantém fila e storage isolados entre jornadas e
 * evita que uma segunda chamada devolva a instância de outro link.
 */
export const makeOnboardingTrackingSDK = (link: string) =>
  makeTrackingSDK({
    name: `onboarding-nca-${link}`,
    client: {
      instance: trackingHttpClient(link),
      endpoint: TRACKING_ENDPOINT,
    },
    source: TRACKING_CONFIG.source,
    flushIntervalMs: TRACKING_CONFIG.flushIntervalMs,
    baseRetryDelayMs: TRACKING_CONFIG.baseRetryDelayMs,
    maxRetries: TRACKING_CONFIG.maxRetries,
    logger: {
      type:
        process.env.REACT_APP_ENVIROMENT === 'production'
          ? 'silent'
          : 'console',
      level: 0,
    },
  });

export const makeRepresentativeTrackingSDK = (representativeId: string) =>
  makeTrackingSDK({
    name: `onboarding-nca-representative-${representativeId}`,
    client: {
      instance: representativeTrackingHttpClient(),
      endpoint: representativeTrackingEndpoint(representativeId),
    },
    source: TRACKING_CONFIG.source,
    flushIntervalMs: TRACKING_CONFIG.flushIntervalMs,
    baseRetryDelayMs: TRACKING_CONFIG.baseRetryDelayMs,
    maxRetries: TRACKING_CONFIG.maxRetries,
    logger: {
      type:
        process.env.REACT_APP_ENVIROMENT === 'production'
          ? 'silent'
          : 'console',
      level: 0,
    },
  });
